<template>
  <div class="page-single">
    <div class="container">
      <div class="row">
        <div class="col col-login mx-auto">
          <div class="text-center mb-6">
            <img src="../../assets/Goalpilot_logo_white_500.png" class="h-6" alt="">
          </div>
          <div class="alert alert-warning" role="alert" v-if="!invitation_code">
            <strong>Warning!</strong> Currently only selected beta users can sign up. Sorry :-(
          </div>
          <div v-else class="alert alert-success">
            You're invitation code is {{invitation_code}}.
          </div>
          <div v-if="not_agreed" class="alert alert-danger" role="alert">
            <strong>Error!</strong> You must agree to terms and conditions before signup.
          </div>
          <div v-if="error_code" class="alert alert-danger" role="alert">
            <strong>Error!</strong> {{error_message}}
          </div>
          <form class="card" @submit.prevent="onSubmit" autocomplete="off">
            <div class="card-body p-6">
              <div class="card-title">Create new account</div>
              <div class="form-group">

                <label class="form-label">Name</label>
                <div class="row gutters-xs">
                  <div class="col-5">
                    <input v-model="userInput.firstName" type="text" class="form-control" placeholder="First name" autocomplete="off">
                  </div>
                  <div class="col-7">
                    <input v-model="userInput.lastName" type="text" class="form-control" placeholder="Family name" autocomplete="off">
                  </div>
                </div>

              </div>
              <div class="form-group">
                <label class="form-label">Email address</label>
                <template v-if="is_prepopulated">
                  <strong>{{userInput.userEmail}}</strong>
                  &nbsp; (<a href="#" @click.prevent="is_prepolated = false">change</a>)
                  <input v-model="userInput.userEmail" type="email" name="hidden" style="display: none" autocomplete="username">
                </template>
                <template v-else>
                  <input v-model="userInput.userEmail" type="email" class="form-control" placeholder="Enter email" autocomplete="username">
                </template>
              </div>
              <div class="form-group">
                <label class="form-label">Password</label>
                <input v-model="userInput.userPassword" type="password" class="form-control" placeholder="Password" autocomplete="new-password">
              </div>
              <div class="form-group">
                <label class="form-label">Confirm password</label>
                <input v-model="userInput.userPasswordConfirm" type="password" class="form-control" placeholder="Password" autocomplete="new-password">
              </div>
              <div class="form-group">
                <label class="custom-control custom-checkbox">
                  <input v-model="userInput.agreeTermsAndPolicy" type="checkbox" class="custom-control-input">
                  <span class="custom-control-label pl-0">
                    Agree the <a href="/terms.html" target="_blank">terms and policy</a>
                  </span>
                </label>
              </div>

              <!-- <script src='https://www.google.com/recaptcha/api.js'></script> -->
              <!--
              <button class="g-recaptcha"
                   data-sitekey="6LfRx5wUAAAAAJ67WwpkhVmpGLVc-z2veJ6uDLad"
                   data-callback="onSubmit">Submit</button> -->
              <div id="recaptcha-container"></div>

              <div class="form-footer">
                <button type="submit" class="btn btn-primary btn-block">Create new account</button>
              </div>
            </div>
          </form>
          <div class="text-center text-muted">
            Already have an account? <a href="#" @click.prevent="onGotoLogin">Sign in</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { load } from 'recaptcha-v3'
import firebase from '@firebase/app'
import resourceLoader from '@/resource-loader'
import Cookies from 'js-cookie'

// TODO: Show errors for humans
// TODO: Also transfer timezone to cloud function
// TODO: Show preview from auth provider
// TODO: integrate https://github.com/DanSnow/vue-recaptcha
// TODO: Make sure users who sign in with google also accept Terms
// TODO: Make sure name is not empty
// xTODO: First name + last name
// xTODO: Ask for password twice

export default {
  data() {
    return {
      not_agreed: false,
      error_code: undefined,
      error_message: '',
      is_prepopulated: false,
      invitation_code: null,
      userInput: {
        firstName: "",
        lastName: "",
        userName: "",
        userEmail: "",
        userPassword: "",
        agreeTermsAndPolicy: false
      }
    };
  },
  mounted() {
    window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');

    // pre populate input with email address from query
    if ( this.$route.query.email ) {
      this.userInput.userEmail = this.$route.query.email;
      this.invitation_code = this.$route.query.code || Cookies.get('invitationCode');
      console.log("invitation_codeinvitation_codeinvitation_code", this.invitation_code)
      this.is_prepopulated = true;
    }

    /*load('6LfRx5wUAAAAAJ67WwpkhVmpGLVc-z2veJ6uDLad').then((recaptcha) => {
      recaptcha.execute('<action>').then((token) => {
        console.log(token) // Will print the token
      })
    })*/
  },
  methods: {
    async onSubmit() {
      console.log("onSubmit", this.userInput);
      if ( this.userInput.userPassword !== this.userInput.userPasswordConfirm ) {
        this.error_code = 1;
        this.error_message = 'Passwords are not the same.'
        return
      }
      this.userInput.userName = this.userInput.firstName + ' ' + this.userInput.lastName;
      /* TODO: Check all input fields (not empty, valid)... or let firebase auth take care */

      let vm = this;
      if (this.userInput.agreeTermsAndPolicy) {
        resourceLoader.beforeUserRegistration( this.userInput );
        this.$api.auth_signup(this.userInput).then((error) => {
          if ( error && "code" in error ) {
            vm.error_code = error.code;
            vm.error_message = error.message;
          } else {
            // this.$emit("user-register", this.userInput);
            resourceLoader.afterUserRegistration({ displayName: this.userInput.userName }, false)
          }
        });
      } else {
        this.not_agreed = true;
      }
    },
    onGotoLogin() {
      this.$router.push("/login");
    }
  }
};
</script>
